import { render, staticRenderFns } from "./ActivateTemplatePopup.vue?vue&type=template&id=272bc7a1&"
import script from "./ActivateTemplatePopup.vue?vue&type=script&lang=js&"
export * from "./ActivateTemplatePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports